export const articles = [
  {
    name: "API Overview",
    path: "API Overview.md",
  },
  {
    name: "Authorization",
    path: "Authorization.md",
  },
  {
    name: "Create a Contract",
    path: "contract-create.md",
    tags: ["API Usage"],
  },
  {
    name: "Create a COR Contract from a Template",
    path: "cor-template-create.md",
    tags: ["API Usage"],
  },
  {
    name: "Create an EOR Contract",
    path: "eor-create.md",
    tags: ["API Usage"],
  },
  {
    name: "MCP Quick Start",
    path: "mcp-quickstart.md",
  },
  {
    name: "MCP Server",
    path: "mcp.md",
  },
  {
    name: "Webhooks Overview",
    path: "webhooks-overview.md",
    tags: ["Webhooks"],
  },
  {
    name: "Verifying Signatures",
    path: "webhooks-verify.md",
    tags: ["Webhooks"],
  },
  {
    name: "Delivery, Retries & Replay",
    path: "webhooks-delivery.md",
    tags: ["Webhooks"],
  },
];
